module.exports = __webpack_public_path__ + "static/img/gutian.513b4f2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/font/gutian.png
// module id = aMgu
// module chunks = 1